import { IntegrationServiceId, MEETING_EXPORT_SUPPORTED_INTEGRATIONS } from '../../../common/integrations'
import { getAccountCRMIntegrationConfig } from '../../../models/Account'
import { useGetMeQuery } from '../../../store/user/user'
import { useGetAccountQuery } from '../../../store/accountUserSettings/accountUserSettings'
import { ActionSuggestion } from '../model'
import { useFilterSuggestions } from './useFilterSuggestions'
import { useAppSelector } from '../../../store/hooks'
import { selectRoomSession } from '../../../store/meetingSummary/roomSession'
import { useMemo } from 'react'
import { selectAccountId } from '../../../store/auth/authSlice'

export const useMeetingExportSuggestions = () => {
  const accountId = useAppSelector(selectAccountId)
  const { data: currentUser } = useGetMeQuery({ accountId })
  const { data: account } = useGetAccountQuery({ accountId })
  const roomSession = useAppSelector(selectRoomSession)

  const crmOptions: IntegrationServiceId[] = useMemo(() => {
    if (!currentUser?.integrations) {
      return []
    }

    return currentUser.integrations
      .filter((i) => MEETING_EXPORT_SUPPORTED_INTEGRATIONS.includes(i.serviceId as IntegrationServiceId))
      .filter((i) => {
        const serviceIntegrationConfig = getAccountCRMIntegrationConfig(account?.data, i.serviceId)
        return !serviceIntegrationConfig || serviceIntegrationConfig.enableFullMeetingExport
      })
      .map((crmIntegration): IntegrationServiceId => {
        const { serviceId } = crmIntegration

        return serviceId as IntegrationServiceId
      })
  }, [currentUser, account])

  const suggestions = useMemo(
    () =>
      roomSession
        ? crmOptions.map(
            (serviceId: IntegrationServiceId): ActionSuggestion => ({
              actionType: 'exportMeeting',
              serviceId: serviceId,
              roomSession: roomSession,
            }),
          )
        : [],
    [crmOptions, roomSession],
  )

  return useFilterSuggestions(suggestions, 'exportMeeting')
}
